module.exports = __webpack_public_path__ + "img/conteudo-titulo.e5fb1b74.png";